module.exports = __webpack_public_path__ + "1b99bd0d.woff2";